module.exports = __webpack_public_path__ + "static/media/item6.197c2444.jpg";